import { SELECT_ALL_RECIPIENTS_FOR_A_PAYER } from "../../actions/action.types";

const toSelectAllRecForPayer = (state = null, action: any) => {
  const type = action.type;
  if (type === SELECT_ALL_RECIPIENTS_FOR_A_PAYER) {
    const payload = action.payload;
    if (payload !== null && payload !== undefined) {
      return payload === "ALL_PAYERS" ? { payerId: "ALL_PAYERS" } : { payerId: payload };
    }
    return state;
  }
  return state;
};

export default toSelectAllRecForPayer;
